module.exports = __webpack_public_path__ + "static/img/pinpai-24.94b3ddcd.png";